export default function Ads2(props: any) {
  const { slot, style, client = "ca-pub-8823204853280729", className = "adsbygoogle" } = props;
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      console.log("ads广告代码执行了:", slot);
      return () => {};
    } catch (error) {}
  }, []);
  // 使用广告观察Hook
  useAdsObserver();
  return (
    <div style={{ textAlign: "center" }} className="google-ad-ads center">
      <ins className={className} style={style} data-ad-client={client} data-ad-slot={slot}></ins>
    </div>
  );
}
